// extracted by mini-css-extract-plugin
module.exports = {"documentsTablePopup":"documentsTablePopup__S7PYm","actionButton":"actionButton__06cXb"};